import cn from 'classnames';

import BaconLeekChicken from 'images/bacon-leek-grilled-chicken.png';
import BajaCitrusSalmon from 'images/baja-citrus-salmon.png';
import TempoTrayAdSource from 'images/tempo-intro-ad-1.png';
import TempoChickenPiccata from 'images/tempo-intro-ad-2.png';
import NavyWaveBorder from 'images/tempoNavyWaveBorder.svg';
import WaveBorder from 'images/tempoWaveBorderDesktop.svg';

const STYLE_VARIANTS = {
  sharapova: {
    waveBorder: NavyWaveBorder,
    rightImage: { src: BaconLeekChicken, alt: 'Bacon Leek Grilled Chicken' },
    leftImage: { src: BajaCitrusSalmon, alt: 'Baja Citrus Salmon' },
    rightClassName:
      'absolute bp1:inset-1/2 bp1:top-28 bp1:translate-x-64 bp3:top-22 -right-10 -top-10 w-36 bp1:-right-6 bp1:w-56',
    leftClassName:
      'absolute bp1:inset-1/2 bp1:top-28 bp1:w-52 bp1:-translate-x-[32rem] bp3:top-22 -left-10 -top-9 w-36 rotate-[-12deg] bp1:rotate-0',
  },
  adSource: {
    waveBorder: WaveBorder,
    rightImage: { src: TempoTrayAdSource, alt: 'Tempo Garlic Sesame Chicken' },
    leftImage: { src: TempoChickenPiccata, alt: 'Tempo Chicken Piccata' },
    rightClassName:
      'absolute -right-6 -top-5 w-24 bp1:inset-1/2 bp1:top-28 bp1:w-52 bp1:translate-x-64 bp3:top-36',
    leftClassName:
      'absolute -left-6 -top-5 w-24 bp1:inset-1/2 bp1:top-28 bp1:w-52 bp1:-translate-x-[32rem] bp3:top-36',
  },
};

const ImageSection = ({ variant = 'adSource' }) => {
  const { waveBorder, rightImage, leftImage, rightClassName, leftClassName } =
    STYLE_VARIANTS[variant];

  return (
    <>
      <div
        style={{ backgroundImage: `url(${waveBorder})` }}
        className="-mt-px h-12 bg-repeat-x p-0 bp1:mb-8"
      />
      <div>
        <img className={cn(rightClassName)} src={rightImage.src} alt={rightImage.alt} />
        <img className={cn(leftClassName)} src={leftImage.src} alt={leftImage.alt} />
      </div>
    </>
  );
};

export default ImageSection;
